import { App as AntdApp, ConfigProvider } from 'antd';
import { BrowserRouter } from 'react-router-dom';

import { ErrorToastProvider } from '@components/ErrorToast';
import { ReviewsProvider } from '@hooks/ReviewsProvider';
import { AppRoutes } from '@routes';
import { antdTheme } from '@styles/antd-theme';

const App = () => (
  <ConfigProvider theme={antdTheme}>
    <AntdApp>
      <ErrorToastProvider>
        <BrowserRouter>
          <ReviewsProvider>
            <AppRoutes />
          </ReviewsProvider>
        </BrowserRouter>
      </ErrorToastProvider>
    </AntdApp>
  </ConfigProvider>
);

export default App;
